import { render } from "./AveTonsFarmerDash.vue?vue&type=template&id=cefb5fe4&scoped=true"
import script from "./AveTonsFarmerDash.vue?vue&type=script&lang=js"
export * from "./AveTonsFarmerDash.vue?vue&type=script&lang=js"

import "./AveTonsFarmerDash.vue?vue&type=style&index=0&id=cefb5fe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefb5fe4"]])

export default __exports__